import { CgiProvider } from "./CGI"

interface Aip {
    union: string
    entryDate: string
    originalEntryDate: string
}

interface BisnodePhoneList {
    type: string
    number: string
    telemarketingRestriction: boolean
}

interface BisnodeAddressList {
    type: string
    subType: string
    streetName: string
    streetNumber: string
    postalCode: string
    city: string
    country: string
    formattedAddress: string[]
}

interface BisnodeEnrichment {
    purchasingPower: string
    phaseOfLife: string
    housingType: string
    education: string
    housingOwnership: string
}

export interface Bisnode {
    gedi: string
    protectedIdentity: boolean
    firstNames: string[]
    preferredFirstName: string
    familyName: string
    gender: string
    dateOfBirth: string
    yearOfBirth: string
    deceased: boolean
    communicationLanguageScript: string
    directMarketingRestriction: boolean
    phoneList: BisnodePhoneList[]
    addressList: BisnodeAddressList[]
    enrichment: BisnodeEnrichment
    deregistered: false
}

export interface CgiActivateResult {
    statusCode: number
    autoStartToken?: string
    qrStartToken?: string
    orderRef?: string
    requestStartedMilliseconds?: number
}

export interface CgiCollectResult {
    statusCode: number
    aipResult: Aip | null
    bisnodeResult: Bisnode | null
    personalIdentityNumber: string | null
    qrCodeData: string;
    progressStatus: CgiProgressStatus;
    userAge: number;
    isYoungEnough: boolean;
}

export enum CgiProgressStatus {
    COMPLETE = 0,
    USER_SIGN = 1,
    OUTSTANDING_TRANSACTION = 2,
    NO_CLIENT = 3, 
    USER_REQ = 4,
    STARTED = 5,
}

export interface SubmissionResponse {
    extensionData: null
    messages: string[]
    success: boolean
}

export interface IsMrmResponse {
    isMrmProduction: boolean;
}

export interface CgiCollectRequest {
    orderRef?: string;
    qrStartToken?: string;
    requestStartedMilliseconds?: number;
    provider: CgiProvider;
}
